export default {
  SET_ERROR_LOGS: function (state, payload) {
    state.errorLogs = payload;
  }
}
